// extracted by mini-css-extract-plugin
export default {"CompanyTopicItem":"company-topic-item_CompanyTopicItem__fEJF1","keywords":"company-topic-item_keywords__sv1tw","labelText":"company-topic-item_labelText__QgRf3"};